import React from "react";
import LandingPageBanner from "../landingPageBanner";
import styled from "./CluesoAuth.module.scss";
import cloudEagle from "../Icons/cloudeagle.svg";
import { CluseoAuthContent } from "./CluseoAuthContent";

const index = () => {
  return (
    <div className={styled.authContainer}>
      <div className={styled.authLCont}>
        <div className={styled.authHeader}>
          <div className={styled.logoCont}>
            <img
              src={cloudEagle}
              style={{
                height: "41px",
              }}
              alt=""
            />
          </div>
        </div>
        <CluseoAuthContent />
      </div>
      <div className={styled.authRCont}>
        <LandingPageBanner />
      </div>
    </div>
  );
};
export default index;
